import { EventConstructorArgs } from '@linktr.ee/event-lib/envelope/Event';
import { useEffect } from 'react';
import { publishPageViewedEvent, publishScreenViewedEvent } from './events';

export const usePublishScreenViewedEvent = (
  screenTitle: EventConstructorArgs<
    'ScreenViewedGolden',
    '14-13-0'
  >['payload']['screen']['screenTitle']
) => {
  useEffect(() => {
    publishScreenViewedEvent(screenTitle);
  }, [screenTitle]);
};

export const usePublishPageViewedEvent = () => {
  useEffect(() => {
    // TODO: we need to figure out how to detect mobile app webview with Descope
    // one Auth0, we only push PageViewed events when not in mobile app webview
    publishPageViewedEvent();
  }, []);
};
